<script>
    import Profile from "./Profile.svelte";

    import {router, navigateTo, PAGE_ID, PAGE_DATA} from "../stores/router";

    let mobile_menu_show = false;

    const menu_pages = Object.keys(PAGE_DATA).map(id => {
        id = parseInt(id, 10);
        return {
            id: id,
            name: PAGE_DATA[id].name,
            in_menu: PAGE_DATA[id].in_menu
        }
    }).filter(item => item.in_menu);

    // $: {
    //     console.log($router);
    // }
</script>


<nav class="bg-gray-800">
    <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div class="flex h-16 justify-between">
            <div class="flex">
                <div class="-ml-2 mr-2 flex items-center md:hidden">
                    <!-- Mobile menu button -->
                    <button on:click={() => mobile_menu_show = !mobile_menu_show}
                            type="button" class="inline-flex items-center justify-center rounded-md p-2 text-gray-400 hover:bg-gray-700 hover:text-white focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white" aria-controls="mobile-menu" aria-expanded="false">
                        {#if !mobile_menu_show}
                        <span class="sr-only">Open main menu</span>
                        <!--
                          Icon when menu is closed.

                          Heroicon name: outline/bars-3

                          Menu open: "hidden", Menu closed: "block"
                        -->
                        <svg class="block h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
                        </svg>
                        {:else}
                        <span class="sr-only">Close main menu</span>
                        <!--
                          Icon when menu is open.

                          Heroicon name: outline/x-mark

                          Menu open: "block", Menu closed: "hidden"
                        -->
                        <svg class="block h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                        {/if}
                    </button>
                </div>
                <div on:click={() => navigateTo(PAGE_ID.DASHBOARD)} class="flex flex-shrink-0 items-center cursor-pointer">
                    <img class="block h-8 w-auto lg:hidden" src="/img/QW_square.svg" alt="Quintwood">
                    <img class="hidden h-8 w-auto lg:block" src="/img/QW_square.svg" alt="Quintwood">
                </div>
                <div class="hidden md:ml-6 md:flex md:items-center md:space-x-4">
                    <!-- Current: "bg-gray-900 text-white", Default: "text-gray-300 hover:bg-gray-700 hover:text-white" -->
                    {#each menu_pages as page}
                        {#if $router.current_page === page.id}
                        <a on:click|preventDefault={() => navigateTo(page.id)} href="/" class="bg-gray-900 text-white px-3 py-2 rounded-md text-sm font-medium" aria-current="page">{page.name}</a>
                        {:else}
                        <a on:click|preventDefault={() => navigateTo(page.id)} href="/" class="text-gray-300 hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md text-sm font-medium">{page.name}</a>
                        {/if}
                    {/each}
                </div>
            </div>
            <div class="flex items-center">
                <div class="flex-shrink-0">
                    <button on:click={() => { navigateTo(PAGE_ID.QUICK_ADD); mobile_menu_show = false; }} type="button" class="relative inline-flex items-center rounded-md border border-transparent bg-indigo-500 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-600 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:ring-offset-gray-800">
                        <!-- Heroicon name: mini/plus -->
                        <svg class="-ml-1 mr-2 h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                            <path d="M10.75 4.75a.75.75 0 00-1.5 0v4.5h-4.5a.75.75 0 000 1.5h4.5v4.5a.75.75 0 001.5 0v-4.5h4.5a.75.75 0 000-1.5h-4.5v-4.5z" />
                        </svg>
                        <span>Quick Add</span>
                    </button>
                </div>
                <div class="hidden md:ml-4 md:flex md:flex-shrink-0 md:items-center">
                    <button type="button" class="rounded-full bg-gray-800 p-1 text-gray-400 hover:text-white focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800">
                        <span class="sr-only">View notifications</span>
                        <!-- Heroicon name: outline/bell -->
                        <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75v-.7V9A6 6 0 006 9v.75a8.967 8.967 0 01-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0" />
                        </svg>
                    </button>

                    <Profile></Profile>
                </div>
            </div>
        </div>
    </div>

    {#if mobile_menu_show}
    <!-- Mobile menu, show/hide based on menu state. -->
    <div class="absolute top-16 right-0 left-0 z-30 bg-gray-800 md:hidden" id="mobile-menu">
        <div class="space-y-1 px-2 pt-2 pb-3 sm:px-3">
            <!-- Current: "bg-gray-900 text-white", Default: "text-gray-300 hover:bg-gray-700 hover:text-white" -->
            {#each menu_pages as page}
                {#if $router.current_page === page.id}
                    <a on:click|preventDefault={() => {
                        navigateTo(page.id);
                        mobile_menu_show = false;
                    }}
                       href="/" class="bg-gray-900 text-white block px-3 py-2 rounded-md text-base font-medium" aria-current="page">{page.name}</a>
                {:else}
                    <a on:click|preventDefault={() => {
                        navigateTo(page.id);
                        mobile_menu_show = false;
                    }}
                       href="/" class="text-gray-300 hover:bg-gray-700 hover:text-white block px-3 py-2 rounded-md text-base font-medium">{page.name}</a>
                {/if}
            {/each}
        </div>
        <!-- TODO temporarily disabling the 'account admin' part of the menus -->
<!--        <div class="border-t border-gray-700 pt-4 pb-3">-->
<!--            <div class="flex items-center px-5 sm:px-6">-->
<!--                <div class="flex-shrink-0">-->
<!--                    <img class="h-10 w-10 rounded-full" src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80" alt="">-->
<!--                </div>-->
<!--                <div class="ml-3">-->
<!--                    <div class="text-base font-medium text-white">Tom Cook</div>-->
<!--                    <div class="text-sm font-medium text-gray-400">tom@example.com</div>-->
<!--                </div>-->
<!--                <button type="button" class="ml-auto flex-shrink-0 rounded-full bg-gray-800 p-1 text-gray-400 hover:text-white focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800">-->
<!--                    <span class="sr-only">View notifications</span>-->
<!--                    &lt;!&ndash; Heroicon name: outline/bell &ndash;&gt;-->
<!--                    <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">-->
<!--                        <path stroke-linecap="round" stroke-linejoin="round" d="M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75v-.7V9A6 6 0 006 9v.75a8.967 8.967 0 01-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0" />-->
<!--                    </svg>-->
<!--                </button>-->
<!--            </div>-->
<!--            <div class="mt-3 space-y-1 px-2 sm:px-3">-->
<!--                <a href="/" class="block rounded-md px-3 py-2 text-base font-medium text-gray-400 hover:bg-gray-700 hover:text-white">Your Profile</a>-->

<!--                <a href="/" class="block rounded-md px-3 py-2 text-base font-medium text-gray-400 hover:bg-gray-700 hover:text-white">Settings</a>-->

<!--                <a href="/" class="block rounded-md px-3 py-2 text-base font-medium text-gray-400 hover:bg-gray-700 hover:text-white">Sign out</a>-->
<!--            </div>-->
<!--        </div>-->
    </div>
    {/if}
</nav>

<style></style>